import { HttpRecordRepository } from './HttpRecordRepository';
import { LocalStorageRecordRepository } from './LocalStorageRecordRepository';
import type { RecordRepository } from './types';

export function createRecordRepository(): RecordRepository {
  const mode = import.meta.env.VITE_RECORD_MODE ?? 'local';
  if (mode === 'http') {
    return new HttpRecordRepository(import.meta.env.VITE_API_BASE_URL ?? '/api/v1');
  }
  return new LocalStorageRecordRepository();
}

export type { RecordRepository, RunRecord, RunResult } from './types';
